exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nameModal .modal-dialog{width:432px!important}.nameModal .modal-content{min-height:200px}.nameModal .signatureWrap{margin-right:125px}.nameModal .nameLine{width:400px}.nameModal .errorDisplay{width:250px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/responses/name_modal.scss
// module id = 919
// module chunks = 0